import React, { useMemo, useState } from "react";
import BarChartWrapper from "components/Dashboard/BarChartWrapper";

const DEFAULT_BAR_COLOR = "rgba(108, 71, 213, 0.8)";

/**
 * Welcome metric 15 payload → rows for dashboard BarChartWrapper (same chrome as metric 14).
 * Keeps per-topic API backgroundColor values; bars sorted by count descending.
 */
export function welcomeMetric15BarToBarChartData(tp) {
  if (!tp || tp.chart_type !== "bar") {
    return { rows: [], datasetLabel: "Participation" };
  }
  const labels = tp.labels || [];
  if (!labels.length) {
    return { rows: [], datasetLabel: "Participation" };
  }
  const ds = tp.datasets?.[0] || {};
  const counts = Array.isArray(ds.data) ? ds.data : [];
  const colors = Array.isArray(ds.backgroundColor) ? ds.backgroundColor : [];
  const datasetLabel =
    ds.label != null && String(ds.label).trim() !== ""
      ? String(ds.label).trim()
      : "Participation";

  const rows = labels.map((label, i) => ({
    label,
    id: `welcome-part-${i}`,
    child: null,
    count: counts[i] != null ? Number(counts[i]) : 0,
    participation: {
      value: counts[i] != null ? Number(counts[i]) : 0,
      color: colors[i] || DEFAULT_BAR_COLOR,
    },
  }));

  rows.sort((a, b) => {
    if (b.count !== a.count) return b.count - a.count;
    return String(a.label).localeCompare(String(b.label), undefined, {
      sensitivity: "base",
    });
  });

  return {
    datasetLabel,
    rows: rows.map((row, j) => ({
      ...row,
      id: `welcome-part-${j}`,
    })),
  };
}

/**
 * Topic Participation (metric 15) — vertical bar chart styled like Sentiment per Topic (metric 14).
 */
export default function WelcomeTopicParticipationBarChart({ payload }) {
  const { rows, datasetLabel } = useMemo(
    () => welcomeMetric15BarToBarChartData(payload),
    [payload],
  );
  const [selectedTopics, setSelectedTopics] = useState({});

  if (!rows.length) return null;

  return (
    <BarChartWrapper
      data={rows}
      selectedTopics={selectedTopics}
      setSelectedTopics={setSelectedTopics}
      metric="participation"
      participationDatasetLabel={datasetLabel}
      stacked={false}
      disableSelection={true}
      onlyOneMetric={false}
      scrollable={true}
    />
  );
}
